import ModalGiftCreateAccount from './ModalGiftCreateAccount'

export default ModalGiftCreateAccount
// eslint-disable-next-line import/export
export * from './ModalGiftCreateAccount'
